import React, { useState, useEffect } from 'react'
import Classnames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import { StatefulTooltip } from 'baseui/tooltip'
import ThemeSwitcher from 'react-css-vars'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'
import ClickAwayListener from 'react-click-away-listener'
// import ModalVideo from 'react-modal-video'
import produce from 'immer'

// state
import { useOnepagerTemplate } from '@/utils/onepager-template'
import { useBuilderSlideout } from '@/utils/builder-slideout'

import { useRecoilValue, useRecoilState } from 'recoil'
import { settings, explainer } from '@/store/template/settings'
import { design } from '@/store/template/design'
import { opTitle, opDesc } from '@/utils/store/onepager_template'
import { isBuilder } from '@/store/builder/store'
import { cssVars } from '@/store/template/design'
import { toggleExplainerModal } from '@/store/onepager/onepager'
import { screen, screenOpen } from '@/store/builder/store'

import { RiPlayCircleLine, RiFileTextLine } from 'react-icons/ri'

// components
import HeroTitle from '@/components/onepager/hero/Title'
import HeroDesc from '@/components/onepager/hero/Desc'
import HeroBranding from '@/components/onepager/hero/Branding'
import HeroCTA from '@/components/onepager/hero/CTA'
import Author from '@/components/onepager/hero/Author'

import ReactPlayer from 'react-player'

import dynamic from 'next/dynamic'
// const CKEditor = dynamic(() => import('@ckeditor/ckeditor5-react'), {   ssr: false, }) HERO area for onepager
const Hero = () => {
  const [playVideo, setPlayVideo] = useState(false)
  const getCSSVars = useRecoilValue(cssVars)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)

  const [isVideoOpen, setVideoOpen] = useState(false)
  const [videoType, setVideoType] = useState('custom')

  // const {   isBuilder,   title,   description,   settings1, } = useOnepagerTemplate();

  const isBuilderCheck = useRecoilValue(isBuilder)

  // const [showExplainerModal, setShowExplainerModal] = useRecoilState(   toggleExplainerModal )

  const [showExplainerModal, setShowExplainerModal] = useState(false)

  const title = useRecoilValue(opTitle)
  const description = useRecoilValue(opDesc)

  const getSettings = useRecoilValue(settings)
  const getDesign = useRecoilValue(design)
  const [getExplainer, setExplainer] = useRecoilState(explainer)

  // const [getExplainerContentOnce, setExplainerContentOnce] = useState(   EditorState.createEmpty() )

  useEffect(() => {
    // check has video but no thumbnail - open video
    if (getSettings.media?.url && !getSettings.media.thumbnail) {
      setVideoOpen(true)
      setPlayVideo(false)
    } else {
      setVideoOpen(false)
      setPlayVideo(false)
    }
  }, [getSettings])

  useEffect(() => {
    // check if video
    if (getSettings.media?.url) {
      let parseVideoUrl = parseVideo(getSettings.media?.url)
      if (parseVideoUrl.type == 'youtube') {
        setVideoType('youtube')
      } else if (parseVideoUrl.type == 'vimeo') {
        setVideoType('vimeo')
      } else {
        setVideoType('custom')
      }
    }
  }, [getSettings])

  function parseVideo(url) {
    url.match(
      /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
    )
    if (RegExp.$3.indexOf('youtu') > -1) {
      var type = 'youtube'
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
      var type = 'vimeo'
    }
    return { type: type, id: RegExp.$6 }
  }

  return (
    <div
      className={Classnames('hero relative lg:px-5 xl:px-0', {
        fullSizeBackground: getDesign.background_fullsize == 'fullsize',
        noHeaderHero: getDesign.header_layout == 'noheader',
      })}
    >
      {/* <ModalVideo
        channel={videoType}
        autoplay={1}
        isOpen={isVideoOpen}
        url={getSettings.media.url}
        videoId={parseVideo(getSettings.media.url).id}
        onClose={() => setVideoOpen(false)}
      /> */}

      {/* CSS VARS THEME - SETTINGS */}
      <ThemeSwitcher theme={getCSSVars} />

      <motion.div
        // initial="hidden"
        // animate="visible"
        // exit="exit"
        // transition={{
        //   duration: 0.4,
        // }}
        // variants={{
        //   hidden: {
        //     opacity: 0,
        //     scale: 0.9,
        //     y: 50,
        //   },
        //   visible: {
        //     opacity: 1,
        //     scale: 1,
        //     y: 0,
        //   },
        //   exit: {
        //     opacity: 0,
        //     scale: 0.9,
        //     y: 50,
        //   },
        // }}
        className="heroInner container max-w-7xl  mx-auto pb-12 pt-6 "
      >
        {/* Branding & CTA  */}
        {/* <div className="heroBrandingCta pb-5  grid-cols-2 items-center ">
          <HeroBranding />
          <div className="heroCTA flex items-center justify-end">
            <HeroCTA />
          </div>
        </div> */}

        {/* COPY - MEDIA */}
        <div
          className={Classnames('md:mt-8', {
            'lg:flex items-center':
              getDesign.header_layout == 'default' || !getDesign.header_layout,
            'flex flex-col justify-center': getDesign.header_layout == 'center',
          })}
        >
          {/* CONTENT */}
          <div
            className={Classnames('px-5 lg:px-0 ', {
              'lg:w-3/5 lg:pr-12':
                getDesign.header_layout == 'default' ||
                !getDesign.header_layout,
              'lg:w-full lg:pr-0 flex flex-col justify-center text-center':
                getDesign.header_layout == 'center',
            })}
          >
            {/* Author Simple */}
            {getSettings?.author?.hide == 'show' && (
              <div
                className={Classnames(
                  'mb-4 md:mb-6 flex-col justify-center  flex items-center',
                  {
                    'md:flex-row md:justify-start':
                      getDesign.header_layout == 'default' ||
                      !getDesign.header_layout,
                    'md:flex-row': getDesign.header_layout == 'center',
                  }
                )}
                style={{
                  fontSize: getDesign.author_text_size
                    ? getDesign.author_text_size + 'px'
                    : '16px',
                  marginBottom: getDesign.author_margin_bottom
                    ? getDesign.author_margin_bottom + 'px'
                    : null,
                }}
              >
                {getSettings?.author?.photo && (
                  <img
                    className="inline-block h-12 w-12 md:h-6 md:w-6 rounded-full mb-2 md:mb-0 mr-4"
                    src={getSettings.author.photo}
                    alt="Author photo"
                  />
                )}
                <div className="heroExpertName font-bold mr-4 expertNameWhite">
                  {getSettings.author.name}
                </div>
                <div className="font-medium  opacity-75 text-center md:text-left">
                  {getSettings.author.tag}
                </div>
              </div>
            )}
            <HeroTitle
              title={title}
              isBuilder={isBuilderCheck}
              headerLayout={getDesign.header_layout}
              getDesign={getDesign}
            />
            <div
              className={Classnames(' mt-3 mb-5', {
                'lg:mr-20':
                  getDesign.header_layout == 'default' ||
                  !getDesign.header_layout,
                'lg:mr-0': getDesign.header_layout == 'center',
              })}
            >
              <HeroDesc
                description={description}
                isBuilder={isBuilderCheck}
                headerLayout={getDesign.header_layout}
                getDesign={getDesign}
              />
            </div>
            {/* LOWER ITEMS */}
            <div
              className={Classnames(
                'flex flex-col space-y-3 md:space-y-0 md:space-x-3 justify-center items-center  md:justify-start md:items-start md:flex-row lg:flex md:mb-3 lg:mb-0',
                {
                  ' md:justify-start md:items-start md:flex-row':
                    getDesign.header_layout == 'default' ||
                    !getDesign.header_layout,
                  ' md:justify-center md:items-center md:flex-row':
                    getDesign.header_layout == 'center',
                }
              )}
            >
              {/* Explainer Read More */}
              {getExplainer.button_title && (
                <div
                  onClick={() => {
                    // check if builder, if it is show explainer, but also open side bar
                    if (isBuilderCheck) {
                      setScreen('explainer')
                      setScreenOpen(true)
                    }
                    setShowExplainerModal(true)
                  }}
                  className={Classnames(
                    'inline-flex md:mb-3 lg:mb-0 md:mr-3 py-2 px-3 pr-5 rounded items-center  hover:scale-105 transform transition duration-300 ease-in-out cursor-pointer',
                    {
                      'bg-black bg-opacity-20 hover:bg-opacity-50':
                        getDesign.text_color == 'white',
                      'bg-white bg-opacity-100 shadow hover:bg-opacity-50':
                        getDesign.text_color == 'black',
                    }
                  )}
                >
                  <div className="inline-flex h-12 text-4xl  items-center  rounded-md mr-2">
                    <RiFileTextLine />
                  </div>
                  <div>
                    <div className="heroExpertName font-bold expertNameWhite">
                      {getExplainer.button_title}
                    </div>
                    <div className="font-medium text-xs md:text-sm opacity-90">
                      {getExplainer.button_subtitle}
                    </div>
                  </div>
                </div>
              )}
              {getSettings.media?.url && (
                <div
                  onClick={() => {
                    if (isVideoOpen) {
                      setPlayVideo(true)
                    }
                    setVideoOpen(true)
                  }}
                  className={Classnames(
                    'inline-flex py-2 px-3 pr-5 rounded items-center  hover:scale-105 transform transition duration-300 ease-in-out cursor-pointer',
                    {
                      'bg-black bg-opacity-20 hover:bg-opacity-50':
                        getDesign.text_color == 'white',
                      'bg-white bg-opacity-100 shadow hover:bg-opacity-50':
                        getDesign.text_color == 'black',
                    }
                  )}
                >
                  <div className="inline-flex h-12 text-4xl  items-center  rounded-md mr-2">
                    <RiPlayCircleLine />
                  </div>
                  <div>
                    <div className="heroExpertName font-bold svelte-djl91p expertNameWhite">
                      {getSettings.media.title}
                    </div>
                    <div className="font-medium text-sm opacity-90">
                      {getSettings.media.subtitle}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* MEDIA */}

          <div
            className={Classnames({
              'lg:w-2/5':
                !getDesign.header_layout ||
                getDesign.header_layout == 'default',
              'w-full px-2 md:px-0 lg:w-2/4 mx-auto flex flex-col items-center justify-center ':
                getDesign.header_layout == 'center',
            })}
          >
            {getSettings.media?.thumbnail && !isVideoOpen && (
              <div className="px-5 md:px-0  md:flex justify-center relative group">
                <img
                  onClick={() => {
                    if (getSettings.media.url) {
                      setVideoOpen(true)
                    }
                  }}
                  src={getSettings.media.thumbnail}
                  className={Classnames('w-full h-auto my-5 md:my-0', {
                    'cursor-pointer': getSettings.media.url,
                  })}
                />
              </div>
            )}

            {/* Only cover image & video video */}
            {/* {
              getSettings.media.thumbnail && getSettings.media.url &&
              <div>
                {!playVideo &&
                  <img onClick={() => { setVideoOpen(true) }} src={getSettings.media.thumbnail} className="shadow-xl rounded-lg cursor-pointer" />
                }
                {
                  playVideo &&
                  <div className='player-wrapper rounded shadow-xl overflow-hidden'>
                    <ReactPlayer controls={true} width='100%' height='100%' className='react-player' url={getSettings.media.url} />
                  </div>
                }
              </div>
            } */}

            {/* Only Video - no cover image */}
            {/* && getDesign.header_layout !== 'center' */}
            {isVideoOpen && (
              <div
                className={Classnames(
                  'player-wrapper rounded mt-5 md:mt-0 shadow-xl overflow-hidden',
                  {
                    'md:mt-10 w-full': getDesign.header_layout == 'center',
                  }
                )}
              >
                <ReactPlayer
                  controls={true}
                  playing={playVideo}
                  width="100%"
                  height="100%"
                  className="react-player"
                  url={getSettings.media.url}
                />
              </div>
            )}
          </div>
        </div>
      </motion.div>

      {/* Explainer Modal */}
      <ScrollLock isActive={showExplainerModal} />
      <AnimatePresence>
        {showExplainerModal && (
          <div className="fixed  max-h-screen z-10 inset-0 bg-black bg-opacity-20 overflow-y-auto explainerModalWrapper">
            <div className="flex md:overflow-y-auto items-end justify-center min-h-screen md:pt-4 md:px-4 md:pb-20 text-center sm:block sm:p-0">
              <div
                onClick={() => {
                  setShowExplainerModal(false)
                }}
                className="absolute top-0 left-0 z-1 bg-black bg-opacity-0 cursor-pointer h-screen w-full"
              ></div>

              <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
                &#8203;
              </span>

              <TouchScrollable>
                <motion.div
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  transition={{
                    duration: 0.15,
                  }}
                  variants={{
                    hidden: {
                      scale: 0.95,
                      opacity: 0,
                    },
                    visible: {
                      scale: 1,
                      opacity: 1,
                    },
                    exit: {
                      scale: 0.95,
                      opacity: 0,
                    },
                  }}
                  className="block md:inline-block relative overflow-y-auto max-h-screen min-h-screen md:max-h-full md:min-h-0  bg-white z-50 rounded-lg px-5 pt-5 pb-4 text-left  shadow-xl mt-0  md:my-20 sm:align-middle sm:max-w-3xl w-full sm:p-10"
                >
                  {/* top meta */}
                  <div
                    onClick={() => {
                      setShowExplainerModal(false)
                    }}
                    className="absolute top-5 right-5 cursor-pointer text-sm bg-gray-100 py-2 px-3 rounded font-medium"
                  >
                    close
                  </div>

                  {/* top title / cover image */}
                  <div className="md:flex  pb-5 ">
                    <div
                      className={Classnames(
                        'flex flex-col  text-center justify-center  w-full ',
                        {
                          'text-center': !getExplainer.content_cover,
                        }
                      )}
                    >
                      <h2 className="font-bold heroTitle  text-3xl md:text-5xl px-10 leading-tight ">
                        {getExplainer.content_title}
                      </h2>
                      <h3 className="font-medium mt-1 md:mt-3 text-base md:text-xl ">
                        {getExplainer.content_subtitle}
                      </h3>
                    </div>
                  </div>

                  {getExplainer.content_cover && (
                    <div className="w-full mt-5 md:mt-0 mb-10">
                      <img
                        className="rounded-lg shadow-lg"
                        src={getExplainer.content_cover}
                      />
                    </div>
                  )}

                  {/* content */}
                  <div className="flex ">
                    <div className="lg:px-20 pb-10 pt-0">
                      <div
                        className="prose prose-sm md:prose-lg"
                        dangerouslySetInnerHTML={{
                          __html: getExplainer.content_html,
                        }}
                      ></div>
                    </div>
                  </div>
                </motion.div>
              </TouchScrollable>
            </div>
          </div>
        )}
      </AnimatePresence>

      {/* section bottom */}

      {/* section - tilt subtle */}
      {/* <div className="headerSectionBottomShape hsTiltRight">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
            className="shape-fill"
          ></path>
        </svg>
      </div> */}
    </div>
  )
}

export default Hero
